/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Class_Doesnotexistaspect4Inputs */



/**

* @param {_Filter_Class_Doesnotexistaspect4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_class_doesnotexistaspect4 = /** @type {((inputs?: _Filter_Class_Doesnotexistaspect4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Class_Doesnotexistaspect4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("existiert nicht")
});
export { _filter_class_doesnotexistaspect4 as "_filter_class_DoesNotExistAspect" }